<template>
  <div>
    <div class="page-title bolder">    <mdb-icon  icon="highlighter" /> 종합결과</div>
    <mdb-row>
      <mdb-col md="3">
      </mdb-col>
      <mdb-col md="9">
        <div class="sub-title mb-5" v-if="training && training._id">
          종합결과 엑셀 다운로드<br>
          <mdb-btn icon="save" @click="download(training._id)">다운로드</mdb-btn>
        </div>
        <div class="sub-title mb-5" v-else>
          먼저 훈련을 선택하세요!!!
        </div>
      </mdb-col>
    </mdb-row>
    <router-view></router-view>
  </div>
</template>
<script>
import axios from 'axios';
import { mapState, mapGetters, mapMutations, mapActions } from 'vuex'
import Summary from '@/models/Summary'
export default {
  name: 'StaffTotalSummary',
  computed: {
    ...mapState('training', ['training'])
  },
  methods: {
    download (training) {
      const url = `/api/summary/gettotalsummary/${training}`
      this.$download(url, 'report.xlsx')
    }
  }
}
</script>
